var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16601 4.83317H9.83268V6.49984H8.16601V4.83317ZM8.99935 13.1665C9.45768 13.1665 9.83268 12.7915 9.83268 12.3332V8.99984C9.83268 8.5415 9.45768 8.1665 8.99935 8.1665C8.54101 8.1665 8.16601 8.5415 8.16601 8.99984V12.3332C8.16601 12.7915 8.54101 13.1665 8.99935 13.1665ZM8.99935 0.666504C4.39935 0.666504 0.666016 4.39984 0.666016 8.99984C0.666016 13.5998 4.39935 17.3332 8.99935 17.3332C13.5993 17.3332 17.3327 13.5998 17.3327 8.99984C17.3327 4.39984 13.5993 0.666504 8.99935 0.666504ZM8.99935 15.6665C5.32435 15.6665 2.33268 12.6748 2.33268 8.99984C2.33268 5.32484 5.32435 2.33317 8.99935 2.33317C12.6743 2.33317 15.666 5.32484 15.666 8.99984C15.666 12.6748 12.6743 15.6665 8.99935 15.6665Z",
    fill: "#654AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a1fb131be6ae8e71cdc58e5825047fdf.svg";
export { ForwardRef as ReactComponent };